import { FieldBase } from '@/components/form/fieldBase';
import ColorPicker from '@/domain/termine/components/ColorPicker/ColorPicker';
import { ColorPickerDrawer } from '@/domain/termine/components/ColorPicker/ColorPickerDrawer';
import { useUpdateTerminKalenderFormContext } from '@/domain/termine/features/UpdateTerminkalender/shared/UpdateTerminKalenderFormContext';
import { isMarkierungType } from '@/domain/termine/shared/types/Markierung';
import { useTranslation } from 'react-i18next';

export function ColorPickerUpdateFormField() {
  const { t } = useTranslation();
  const form = useUpdateTerminKalenderFormContext();
  return (
    <form.AppField name="markierung">
      {(field) => {
        const handleChange = (value: string) => {
          if (isMarkierungType(value)) {
            field.handleChange(value);
            field.handleBlur();
          }
        };

        return (
          <FieldBase
            label={t('domain.termine.form.fields.farbe')}
            className="w-fit">
            <div className="block md:hidden">
              <ColorPickerDrawer
                value={field.state.value}
                onChange={handleChange}
              />
            </div>
            <div className="hidden md:block">
              <ColorPicker value={field.state.value} onChange={handleChange} />
            </div>
          </FieldBase>
        );
      }}
    </form.AppField>
  );
}
